import React from 'react';

export interface IOption {
    value: string;
    label: string;
}

export type TProfileTab =
    | 'main'
    | 'profile'
    | 'agency'
    | 'adverts'
    | 'bookmarks'
    | 'plans'
    | 'logout';

export interface ISidebarContextType {
    isSidebarOpen: boolean;
    showSidebar: (e?: React.MouseEvent) => void;
    closeSidebar: () => void;
}

export type TTokenResponse = {
    token: string;
    accessToken: string;
    refreshToken: string;
    expiration: string;
};

export type TUser = {
    id: string;
    email: string;
    emailConfirmed: boolean;
    name: string;
    surname: string;
    twoFactorEnabled: boolean;
    username: string;
    role: string;
    phoneNumber: string;
    createdAt: Date;
    updatedAt: Date;
    balance: number;
    addCount: number;
    activeAdsCount: number;
    rejectedAdsCount: number;
    expiredAdsCount: number;
    deactivateAddCount: number;
    image: string;
    userType: UserType;
    agencyName: string;
    agencyDescription: string;
    whatsappPhoneNumber?: string;
    telegramUserName?: string;
    isFirstAdPost: boolean;
    selectedPlanId?: string;
    selectedPlanPurchaseDate?: string;
    selectedPlan?: {
        expireDate: string;
        discountPercentage: number;
        durationInDays: number;
        hasAdDiscount: boolean;
        hasPromotion: boolean;
        id: string;
        maxPosts: number;
        name: string;
        planBalanceForPurchases: number;
        price: number;
        remainPlanAdsCount: number;
    };
};

export enum UserType {
    USER = 'User',
    AGENCY = 'Agency',
    ADMIN = 'Admin',
}

export type FileWithPreview = {
    id: string;
    preview: string;
    file: File | null;
    index: number;
    rotate: number;
};

export enum ADVERT_STATUS {
    ALL = 'All',
    Pending = 'Pending',
    Expired = 'Expired',
    Active = 'Active',
    Rejected = 'Rejected',
}

export enum ADVERT_OWNER_TYPE {
    OWNER = 'Owner',
    AGENCY = 'Agency',
    INTERMEDIARY = 'Intermediary',
}

export enum ADVERT_TYPE {
    RENT = 'Rent',
    SALE = 'Sale',
}

export enum PROPERTY_TYPE {
    NEW_BUILDING = 'NewBuilding',
    OLD_BUILDING = 'OldBuilding',
    YARD_HOUSE = 'YardHouse',
    OFFICE = 'Office',
    GARAGE = 'Garage',
    LAND = 'Land',
    COMMERCIAL = 'Commercial',
}

export enum BUILDING_TYPE {
    BUSINNESS_CENTER = 'BusinessCenter',
    HOME = 'Home',
    VILLA = 'Villa',
}

export enum MAINTENANCE_STATUS {
    FULL = 'Full',
    AVERAGE = 'Average',
    BAD = 'Bad',
}

export enum DOCUMENT_STATUS {
    YES = 'Yes',
    NO = 'No',
}

export enum MORTGAGE_STATUS {
    YES = 'Yes',
    NO = 'No',
}

export enum PRICE_TYPE {
    MONTHLY = 'Monthly',
    DAILY = 'Daily',
}

export enum ADVERT_LIST_SORT_TYPE {
    CHEAPEST = 0,
    EXPENSIVE = 1,
    NEWEST = 2,
    OLDEST = 3,
}

export enum ADVERT_UPGRADE_PLAN {
    FORWARD = 'Forward',
    VIP = 'VIP',
    PREMIUM = 'Premium',
}
